<template>
	<div id="header">
		<div class="header_L">
			<div class="headerL_logo"></div>
			<div class="headerL_title">电话访问系统</div>
		</div>
		<div id="headerS">
			<div class="headerS_red"></div>
			<div id="stausDiv">初始化...</div>
			<div class="stausHelp" @click="helpDialog">?</div>
		</div>
		<div id="PhoneBarDiv"></div>
		<div class="header_R">
			<div class="header_Rproject" @click="openProject(1)">
				<i class="icon dficonfont icon-caidanguanli-copy"></i>
				选择项目
			</div>
			<span class="vertical"></span>
			<div class="header_Ruser">欢迎您 , {{ user.username }}</div>
			<span class="vertical"></span>
			<div class="header_Rquit" @click="tuichu">
				<i class="icon dficonfont icon-tuichu"></i>
				退出
			</div>
		</div>
		<project ref="project"></project>
		<!-- 提示对话框 -->
		<el-dialog title="帮助" @open="openDialog()" ref="dialog" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
			<div class="stausHelpText" v-html="helptxt"></div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import project from './project';
export default {
	components: {
		project
	},
	data() {
		return {
			helptxt:'',
			dialogVisible: false,
			user: {}
		};
	},
	mounted() {
		if (window.localStorage.getItem('userInfo') == null) {
			this.$router.push({ path: '/login' });
			return false;
		}
		this.user = JSON.parse(window.localStorage.getItem('userInfo'));
		console.log('用户信息', this.user);
		this.openProject(0);
		// this.$refs.dialog.open();
		// console.log(this.$refs.dialog.dialogModal)
		// this.$refs.dialog.dialogModal= false
	},
	methods: {
		openDialog() {
			console.log('打开回调',dialcontroller.help(),$('.stausHelpText'))
			$('.stausHelpText').html(dialcontroller.help());
		},
		helpDialog() {
			$('.stausHelpText').html(dialcontroller.help());
			this.helptxt = dialcontroller.help()
			this.dialogVisible = true;
		},
		handleClose(done) {
			done();
		},
		tuichu() {
			if (dialcontroller.workbench.BannedClick == true) {
				let that = this;
				let params = {
					that: this,
					method: 'POST',
					url: `${this.$config.service.loginOut}`,
					cb(res) {
						// if (res.result == '111111111111') {
							try {
								dialcontroller.DisconnectServer();
								localStorage.removeItem('userInfo');
								localStorage.removeItem('token');
								localStorage.removeItem('prCode');
								localStorage.removeItem('sCode');
								localStorage.removeItem('projectinfo');
								this.$store.state.pr_Code = ''; //项目id
								this.$store.state.s_Code = ''; //样本id
								this.$store.state.pindex = ''; //中断页
								this.$store.state.projectinfo = {}; //项目
							} catch (e) {}
							that.$router.push('/login');
						// } else {
						// 	that.$message.error(res.msg);
						// }
					}
				};
				this.$util.request(params);
			} else {
				this.$message.warning('您有未处理完成的样本信息,请处理后再退出!');
			}
		},
		openProject(type) {
			if (type == 0 || dialcontroller.workbench.BannedClick == true) {
				this.$refs.project.openProject();
			} else {
				if (type == 1) {
					this.$message.warning('您有未处理完成的样本信息,请处理后再更换项目!');
				}
			}
		}
	}
};
</script>

<style scoped lang="scss">
#header {
	width: 100%;
	margin-top: 5px;
	background-color: #ffffff;
	display: flex;
	justify-content: space-between;
	.header_L {
		width: 327px;
		height: 48px;
		display: flex;
		cursor: pointer;
		margin-left: 20px;
		.headerL_logo {
			width: 178px;
			height: 52px;
			background-image: url(../assets/logo.png);
			background-size: 100% 100%;
		}
		.headerL_title {
			width: 121px;
			font-family: MicrosoftYaHei-Bold;
			font-size: 20px;
			font-weight: 800;
			font-style: italic;
			font-stretch: normal;
			line-height: 48px;
			letter-spacing: 0px;
			color: #333333;
			margin-left: 9px;
		}
	}
	#headerS {
		width: 300px;
		display: flex;
		.headerS_red {
			width: 15px;
			height: 15px;
			background-color: orangered;
			border-radius: 50%;
			margin-top: 17.5px;
		}
		#stausDiv {
			line-height: 50px;
			margin-left: 5px;
		}
		.stausHelp {
			line-height: 50px;
			margin-left: 5px;
			cursor: pointer;
			display: none;
		}
		.stausHelp:hover {
			color: #0080ff;
		}
	}
	#PhoneBarDiv {
		display: none;
	}
	.header_R {
		width: 295px;
		height: 40px;
		margin-top: 5px;
		display: flex;
		justify-content: space-between;
		line-height: 40px;
		.header_Rproject {
			font-size: 14px;
			color: #0080ff;
			cursor: pointer;
		}
		.header_Ruser {
			font-size: 14px;
			color: #333333;
			cursor: pointer;
		}
		.header_Rquit {
			font-family: MicrosoftYaHei;
			color: #333333;
			cursor: pointer;
		}
		.header_Rquit:hover {
			color: #0080ff;
		}
		.vertical {
			width: 1px;
			height: 40px;
			background-color: #e1e1e1;
		}
	}
}
</style>
